import { render, staticRenderFns } from "./Generarecetas.vue?vue&type=template&id=01b91534&scoped=true"
import script from "./Generarecetas.vue?vue&type=script&lang=js"
export * from "./Generarecetas.vue?vue&type=script&lang=js"
import style0 from "./Generarecetas.vue?vue&type=style&index=0&id=01b91534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b91534",
  null
  
)

export default component.exports